import { useNavigate } from "react-router-dom";
import Image from '../../../components/Image.tsx';
import { useAlert } from "../../../contexts/alertProvider.tsx";
import formatNumber from "../../../models/helpers/formatNumber.ts";
import IsNullOrEmpty from "../../../models/helpers/isNullOrEmpty.ts";
import { SearchResult } from "../../../models/search/searchResult";
import { StatusCode } from "../../Alert.tsx";
import FormButton from "../../form/FormButton.tsx";

const ResultsList = ({
    results
}: {
    results: SearchResult[];
}) => {
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const fallbackCopyToClipboard = (text: string) => {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed"; // avoid scroll jump
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
            const successful = document.execCommand("copy");
            document.body.removeChild(textarea);
            return successful;
        } catch (err) {
            document.body.removeChild(textarea);
            return false;
        }
    };

    const handleShare = (result: SearchResult) => {
        const shareUrl = `${window.location.origin}/${result.type}s/${result.resultID}`;

        if (navigator.share) {
            navigator
                .share({
                    title: result.name,
                    text: `Check out this ${result.type.toLowerCase()}: ${result.name}`,
                    url: shareUrl
                })
                .catch(err => console.error("Error sharing:", err));
        } else if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(shareUrl)
                .then(() => {
                    showAlert(StatusCode.success, "Link copied to clipboard!");
                })
                .catch(() => {
                    if (fallbackCopyToClipboard(shareUrl)) {
                        showAlert(StatusCode.success, "Link copied to clipboard!");
                    } else {
                        showAlert(StatusCode.error, "Unable to copy link.");
                    }
                });
        } else {
            if (fallbackCopyToClipboard(shareUrl)) {
                showAlert(StatusCode.success, "Link copied to clipboard!");
            } else {
                showAlert(StatusCode.error, "Unable to copy link.");
            }
        }
    };

    return (
        <div className="card-deck d-flex flex-row flex-wrap justify-content-around w-100">
            {results.map(result => (
                <div className="card mt-2 w-10rem" key={`${result.type}-${result.resultID}`} onClick={() => navigate(`/${result.type}s/${result.resultID}`)}>
                    <Image
                        entityType={result.type}
                        entityID={result.resultID}
                        className="card-img-top w-auto h-10rem"
                        useFallback
                    />
                    <div className="card-body">
                        <h5 className="card-title">{result.name}</h5>
                        {!IsNullOrEmpty(result.brand) && !result.name.includes(result.brand) && !result.brand.includes(result.name) && <small className="text-muted">{result.brand}</small>}
                    </div>
                    <div className="ms-3 me-2 mb-2 d-flex flex-row justify-content-between">
                        <small className="text-muted my-auto">{formatNumber.ToFixed(result.nutritionalValues?.calories) ?? '...'} kCal</small>
                        <FormButton
                            icon='box-arrow-up'
                            color='success'
                            onClick={(e) => {
                                e.stopPropagation(); // Prevent card click navigation
                                handleShare(result);
                            }}
                            mb={0}
                        />
                    </div>
                </div>))}
        </div>
    )
}

export default ResultsList;